import { ISavedFilter } from '../../../components/sidebar-filters/saved-filter/interface';
import { SavedFiltersList } from '../../../components/sidebar-filters/SavedFiltersList';
import { useEventTrackingSidebarFiltersContext } from './EventTrackingSidebarFiltersContext';

interface IEventTrackingSidebarSavedProps {
    onOpenSaveFiltersModal: (filter: ISavedFilter) => void;
}

export const EventTrackingSidebarSaved: React.FC<IEventTrackingSidebarSavedProps> = ({ onOpenSaveFiltersModal }) => {
    const { savedFilters, appliedSavedFilter, handleApplySavedFilter, handleDeleteSavedFilter, handleSavedFilterSelect, selectedSavedFilter } =
        useEventTrackingSidebarFiltersContext();

    const onDeleteSavedFilter = async (filter: ISavedFilter) => {
        await handleDeleteSavedFilter(filter);

        if (selectedSavedFilter?.id === filter.id) {
            handleSavedFilterSelect(null);
        }
    };

    return (
        <div
            style={{
                display: 'flex',
                flexDirection: 'column',
                width: '100%',
                height: '100%',
            }}
        >
            <SavedFiltersList
                savedFilters={savedFilters}
                appliedSavedFilter={appliedSavedFilter}
                onOpenSaveFiltersModal={onOpenSaveFiltersModal}
                onDeleteSavedFilter={onDeleteSavedFilter}
                onApplySavedFilter={handleApplySavedFilter}
            />
        </div>
    );
};
